import {BaseFormModel} from './base-form-model';

export class MenuModifier extends BaseFormModel<MenuModifier> {
    id: number;
    name: string;
    description: string;
    selectionOption: boolean;
}
